"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.momentFormatTime2 = exports.momentFormatTime = exports.momentFormatDate = exports.momentFormatTimeOrDate = exports.momentFormatDateTimeSeconds = exports.momentFormatDateTime = void 0;
const find_1 = __importDefault(require("lodash/find"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const pluralize_1 = __importDefault(require("pluralize"));
const GeocodeResult_1 = require("../models/google-maps/GeocodeResult");
const unwrap_1 = __importDefault(require("../util/unwrap"));
class MomentHelper {
    static daysHoursMinues(duration) {
        return [
            stringOrFalse(duration.days(), 'day'),
            stringOrFalse(duration.hours(), 'hour'),
            stringOrFalse(duration.minutes(), 'minute'),
        ]
            .filter(Boolean)
            .join(' ');
    }
    static daysHoursMinutesFromSeconds(seconds) {
        return this.daysHoursMinues(moment_timezone_1.default.duration(seconds, 'seconds'));
    }
    static timezoneForOffset(country, offsetM) {
        const zones = moment_timezone_1.default.tz.zonesForCountry(country, true);
        const zone = (0, find_1.default)(zones, _ => _.offset === offsetM);
        const name = (0, unwrap_1.default)(zone, _ => _.name);
        return name;
    }
    static timezoneForAddressComponents(components, offsetM) {
        const country = (0, GeocodeResult_1.geocodeResultCountry)(components);
        const timezone = (0, unwrap_1.default)(country, _ => this.timezoneForOffset(_, offsetM));
        return timezone;
    }
    static roundUpMinutes(m1, minutes) {
        const remainder = minutes - (m1.minutes() % minutes);
        return (0, moment_timezone_1.default)(m1).add(remainder, 'minutes');
    }
}
exports.default = MomentHelper;
function stringOrFalse(value, unitString) {
    if (value) {
        // i.e., if not zero
        return `${value} ${(0, pluralize_1.default)(unitString, value)}`;
    }
    else {
        return false;
    }
}
function momentFormatDateTime(moment) {
    return moment.format('MM/DD/YYYY [at] h:mm a');
}
exports.momentFormatDateTime = momentFormatDateTime;
function momentFormatDateTimeSeconds(moment) {
    return moment.format('MM/DD/YYYY [at] h:mm:ss a');
}
exports.momentFormatDateTimeSeconds = momentFormatDateTimeSeconds;
/**
 * Not tested
 */
function momentFormatTimeOrDate(moment) {
    return moment.calendar({
        sameDay: 'LT',
        sameElse: 'MM/DD/YYYY',
    });
}
exports.momentFormatTimeOrDate = momentFormatTimeOrDate;
function momentFormatDate(moment) {
    return moment.format('MM/DD/YYYY');
}
exports.momentFormatDate = momentFormatDate;
function momentFormatTime(moment) {
    return moment.format('LT'); // h:mm A z
}
exports.momentFormatTime = momentFormatTime;
function momentFormatTime2(moment) {
    return moment.format('h:mma z');
}
exports.momentFormatTime2 = momentFormatTime2;
